export default __webpack_public_path__ + "static/media/influencer_card1.9b3a05f7.png";